import { render, staticRenderFns } from "./MeetingAnnouncement.vue?vue&type=template&id=3a58a896&"
import script from "./MeetingAnnouncement.vue?vue&type=script&lang=js&"
export * from "./MeetingAnnouncement.vue?vue&type=script&lang=js&"
import style0 from "./MeetingAnnouncement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a58a896')) {
      api.createRecord('3a58a896', component.options)
    } else {
      api.reload('3a58a896', component.options)
    }
    module.hot.accept("./MeetingAnnouncement.vue?vue&type=template&id=3a58a896&", function () {
      api.rerender('3a58a896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/MeetingAnnouncement.vue"
export default component.exports